import 'rc-tooltip/assets/bootstrap.css';
import 'rc-slider/assets/index.css';
import './App.css';
import React from 'react'
import _ from 'lodash';
import $ from 'jquery';
import KeywordInput from './keyword-input'
import KeywordExamples from './keyword-examples'
import MiniNav from './mininav'
import Switch from "react-switch";
import netlifyIdentity from 'netlify-identity-widget';
import TextLoader from './text-loader'
import TypeIt from "typeit-react";

import testData from './test-data'

class App extends React.Component{

    constructor(props){
      super(props);

      this.state = {
        keyword: '',
        submittedKeyword: '',
        response: null,
        error: '',
        idea: null,
        relatedSearches: null,
        isLoading: false,
        currentUser: null,
        showSignupWall: false,
      }

      this.typeitOptions = {
        speed: 20,
        waitUntilVisible: true,
        nextStringDelay: 0,
        cursor: false
      }
    
      this.handleCalculate = this.handleCalculate.bind(this);
      this.animateIdea = this.animateIdea.bind(this);
      this.signIn = this.signIn.bind(this);
      this.signUp = this.signUp.bind(this);
      this.ideaToText = this.ideaToText.bind(this);
      this.copyIdeaToClipboard = this.copyIdeaToClipboard.bind(this);
      this.showHarmfulOutputForm = this.showHarmfulOutputForm.bind(this);

      this.useTestData = false;
      // this.rootUrl = 'http://localhost:3000';
      this.rootUrl = 'https://app.usetopic.com';
    }

    componentDidMount(){
      var that = this;
      if(this.useTestData && testData && _.isObject(testData)){
        this.setState({
          response: testData,
          isLoading: false,
          error: '',
          keyword: "test",
          submittedKeyword: "test"
        });
      }

      netlifyIdentity.on('init', (user) => {
        that.setState({
          currentUser: user,
          showSignupWall: false
        });
      });
      netlifyIdentity.on('login', (user) => {
        that.setState({
          currentUser: user,
          showSignupWall: false
        });
        netlifyIdentity.refresh().then((jwt)=>{
          if(window.location.href.indexOf('blog-idea-generator.netlify.app') !== -1){
            window.location.href = `https://www.usetopic.com/blog-idea-generator#access_token=${jwt}`;
          }
        });
      });
      netlifyIdentity.on('logout', () => {
        that.setState({
          showSignupWall: true,
          currentUser: null
        });
      });

      netlifyIdentity.on('close', () => {
        window.location.reload();
      });

      netlifyIdentity.init({
        APIUrl: 'https://blog-idea-generator.netlify.app/.netlify/identity'
      });
    }

    componentDidUpdate(){
      if($('.search-result-item-idea').length > 0){
        this.animateIdea();
      }
    }

    componentWillUnmount(){
      netlifyIdentity.off('init');
      netlifyIdentity.off('login');
      netlifyIdentity.off('logout');
    }

    animateIdea(){
      var {idea} = this.state;
      $('.search-result-wrapper').addClass('active');
      window.setTimeout(() => {
        $('.search-result-item-idea').css('opacity', 1);
      }, 50);
      window.setTimeout(() => {
        $('.title-box').removeClass('opacity-0');
      }, 75);
      window.setTimeout(() => {
        $('.search-result-item-idea .opacity-0').removeClass('opacity-0');
      }, 100);
    }

    handleCalculate(e){
      var that = this;
      var {keyword, isLoading, currentUser} = this.state;

      // comment this out if you want to disable forced-signup
      if(currentUser === null){
        this.setState({
          showSignupWall: true
        });
        return;
      }

      if(_.isString(e)){
        keyword = e; // called from keyword-examples
        that.setState({keyword: keyword});
      } else{
        e.preventDefault();
      }
      
      if(isLoading){
        alert('Please wait while we generate your blog post idea. This may take a minute.');
        return;
      } else if(keyword.trim().length === 0){
        alert('Please enter a valid topic.');
        return;
      }
      this.setState({
        isLoading: true,
        submittedKeyword: keyword
      })

      async function postData(url = '', data = {}) {
        // Default options are marked with *
        const response = await fetch(url, {
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'Content-Type': 'application/json'
          }
        });
        return response.json(); // parses JSON response into native JavaScript objects
      }

      if(this.useTestData){
        that.setState({
          error: '',
          submittedKeyword: testData.success.keyword
        });
      } else{
        var email;
        if(currentUser && currentUser.email){
          email = `?email=${encodeURIComponent(currentUser.email)}`;
        }
        postData(`${that.rootUrl}/api/openai/content_idea/${encodeURIComponent(keyword)}${email}`)
          .then(data => {
            console.log(data);
            if(data.error){
              that.setState({
                error: data.error,
                isLoading: false
              })
            } else if(data.filter === "1"){
              that.setState({
                error: "The content filter has flagged this generation, not because discussion of this topic is necessarily wrong, but because this system can discuss some topics using unsafe or insensitive language. You can try again with the same prompt, or with something new.",
                isLoading: false
              })
            } else if(data.filter === "2"){
              that.setState({
                error: "The content filter has flagged this generation, not because discussion of this topic is necessarily wrong, but because this system can discuss some topics using unsafe or insensitive language. You can try again with the same prompt, or with something new.",
                isLoading: false
              })
            } else if(!_.isEmpty(data.ideas)){
              that.setState({
                error: '',
                idea: data.ideas[0],
                relatedSearches: data.related_searches,                
                isLoading: false
              });
            } else{
              that.setState({
                error: 'Something went wrong getting the recommendation. Please contact support@usetopic.com',
                isLoading: false
              })
            }
          });
      }
    }

    signIn(){
      netlifyIdentity.open('login');
    }

    signUp(){
      netlifyIdentity.open('signup');
    }

    showHarmfulOutputForm(){
      var {keyword, idea} = this.state;
      var formUrl = `https://blog-idea-generator-harmful-content.paperform.co?keyword=${encodeURIComponent(keyword)}&content=${encodeURIComponent(this.ideaToText(idea))}`;
      window.open(formUrl,"mywindow","width=450,height=600");
    }

    ideaToText(idea){
      var text = `# Title
${idea.title}

# Description
${idea.description}
`;

      return text;
    }

    copyIdeaToClipboard(){
      var text = this.ideaToText(this.state.idea);
      navigator.clipboard.writeText(text);
      var originalButtonText = $('.copy-button-text').text();
      $('.copy-button-text').text('Copied!');
      setTimeout(() => {
        $('.copy-button-text').text(originalButtonText);
      }, 500);
    }

    render(){
      var that = this;
      var {keyword, isLoading, error, idea, relatedSearches, submittedKeyword, currentUser, showSignupWall} = this.state;
      var showResults = !isLoading && idea && !error;
      var showError = !isLoading && error;

      return (

        <div className="App">
          {!showSignupWall && <React.Fragment>

          <MiniNav currentUser={currentUser} onLogout={() => { netlifyIdentity.logout(); }} />
          <KeywordInput keyword={keyword} onClick={this.handleCalculate} onChange={(e) => {that.setState({keyword: e.target.value});}} isLoading={isLoading} />
          <KeywordExamples onClick={(keyword) => { this.handleCalculate(keyword); }} relatedSearches={relatedSearches} />
          </React.Fragment>}

          {showSignupWall && <div className="signUpWall" style={{textAlign: 'center', paddingBottom: '200px'}}>
            <div>
              Almost there! Create a free account to get access to: 
              <div style={{marginTop: '10px'}}><i className="fas fa-check" /> unlimited blog ideas</div>
              <div><i className="fas fa-check" /> ideas optimized for search</div>
              <div><i className="fas fa-check" /> access to more free tools</div>
            </div>
            <button onClick={this.signUp} className="pushable" style={{marginTop: '30px', marginBottom: '10px'}}>
              <span className="pushable-shadow"></span>
              <span className="pushable-edge"></span>
              <span className="pushable-front">
                Create Free Account
              </span>
            </button>
            <br />
            or <a href="#" onClick={this.signIn}>log in</a>
          </div>}

          {
            isLoading && <TextLoader
            animationIntervalSpeed={2000}
            lines={[
              'Queueing blog idea generation job',
              `Searching Google for "${submittedKeyword}"`,
              'Identifying target persona',
              'Analyzing search intent',
              'Finding patterns in content',
              'Initializing creativity engine',
              'Removing boring outputs'
            ]} />
          }

          <div className="search-result-wrapper">
            {showResults && <div className="title-box opacity-0"><h2 className="heading-h2">Here's an idea:</h2></div>}
            <div className="search-result-box-single">
              {showError && <div className="search-result-item-idea" style={{marginTop: '30px'}}>
                               <div className="search-result-item-title">Oops, we've run into an issue</div>
                               <div className="search-result-item-text">{error}</div>
                            </div>}

              {showResults && <React.Fragment>
                <div className="search-result-item-idea">
                  <div href="#" className="copy-button w-button clickable" onClick={this.copyIdeaToClipboard}>
                    <div className="copy-button-icon"><i className="far fa-clipboard" /></div>
                    <div className="copy-button-text">Copy to Clipboard</div>
                  </div>
                   <div className="search-result-item-title opacity-0">{idea.title}</div>
                   <div className="search-result-item-text opacity-0"><TypeIt element={"div"} options={this.typeitOptions}>{idea.description}</TypeIt></div>
                   <div>
                    <div className="search-result-item-outline"></div>
                    <div className="search-result-item-gradient"></div>
                   </div>
                   <div className="button-row"><a className="button-blue full w-button btn-unlock-outline" href="https://www.usetopic.com" target="_blank"><i className="fas fa-lock-alt" /> Create Content Brief</a></div>
                   <div className="harmful-output">
                    <a href="#" onClick={this.showHarmfulOutputForm}>Report Harmful Output</a>
                   </div>
                </div>
              </React.Fragment>}
            </div>
          </div>
        </div>
      );
    }

}

export default App